module.exports = __webpack_public_path__ + "img/ck.ae3ea163.svg";